var swiper = new Swiper('.review_slider', {
  slidesPerView: 'auto',
  paginationClickable: true,
  loop: false,
  centeredSlides: false,
  slideToClickedSlide: true,
    navigation: {
    nextEl: '.customer-swiper-button-next',
    prevEl: '.customer-swiper-button-prev',
  },
  scrollbar: {
    el: '.customer-swiper-scrollbar',
  },
  breakpoints: {
    // when window width is >= 320px
    749: {
      loop: false,
       slidesPerView: 'auto',
    }
  }
});

const mediaQuery = window.matchMedia('(max-width: 719px)')
if (mediaQuery.matches) {
  
var swiper2 = new Swiper('.instagram_main-slider', {
  slidesPerView: 2.4,
  paginationClickable: true,
  loop: false,
  slideToClickedSlide: true,
    navigation: {
    nextEl: '.insta-swiper-button-next',
    prevEl: '.insta-swiper-button-prev',
  },
  scrollbar: {
    el: '.insta-swiper-scrollbar',
  }
});


var swiper3 = new Swiper('.image-slider-cover', {
  slidesPerView: 1.1,
  paginationClickable: true,
  loop: false,
  slideToClickedSlide: true,
  spaceBetween:17,
    navigation: {
    nextEl: '.image-swiper-button-next',
    prevEl: '.image-swiper-button-prev',
  },
  scrollbar: {
    el: '.image-swiper-scrollbar',
  }
});

}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.variant-tab-nav .tab-target').forEach(function(tabLink) {
    let targetIdent = tabLink.getAttribute('data-for');
    tabLink.addEventListener('click', function() {
      document.querySelectorAll('.product-variant-cover').forEach(function(tab) {
        tab.classList.remove('active');
        tabLink.closest('.product-variant-main-wrap').querySelectorAll('.choose-size-button').forEach(function(btn) {
          if (btn.getAttribute('data-for') === targetIdent) {
            btn.classList.add('active');
          } else {
            btn.classList.remove('active');
          }
        })
      });
      
      var tabId = this.getAttribute('data-id');
      document.querySelector(".product-variant-cover[data-id='" + tabId + "']").classList.add('active');
      
      document.querySelectorAll('.variant-tab-nav .tab-target').forEach(function(tabLink) {
          tabLink.classList.remove('active');
      });
      this.classList.add('active');
    });
  });
  document.querySelector('#customToggle')?.addEventListener('click', function() {
    document.querySelector('.variant-tab-nav .tab-target:not(.active)')?.click();
  })
});


document.addEventListener('DOMContentLoaded', function() {
  var firstImageTab = document.querySelector('.data-tab-column');
  if (firstImageTab) {
    firstImageTab.classList.add('tab-active');
  }

   var firstThumbnailCover = document.querySelector('.tabbing-list .tab-target, .data-tab-column:before');
  if (firstThumbnailCover) {
    firstThumbnailCover.classList.add('tab-active');
  }

  document.querySelectorAll('.tabbing-list .tab-target, .data-tab-column:before').forEach(function(tabLink) {
    tabLink.addEventListener('click', function() {
      document.querySelectorAll('.data-tab-column').forEach(function(tab) {
        tab.classList.remove('tab-active');
      });

      var tabId = this.getAttribute('data-id');
      document.querySelectorAll(".data-tab-column[data-id='" + tabId + "']").forEach(function(tab) {
        tab.classList.add('tab-active');
      });

      document.querySelectorAll('.tabbing-list .tab-target, .data-tab-column:before').forEach(function(tabLink) {
        tabLink.classList.remove('tab-active');
      });
      this.classList.add('tab-active');
    });
  });
});




document.addEventListener('DOMContentLoaded', function() {
  var headings = document.querySelectorAll('.data-tab-cover .tabbing-list-mobile');
  
  // if (headings.length > 0) {
  //   // Display the first tab by default
  //   var firstHeading = headings[0];
  //   firstHeading.classList.add('active');
  //   firstHeading.nextElementSibling.style.display = "block";
  // }

  headings.forEach(function(heading) {
    heading.addEventListener('click', function() {
      var description = this.nextElementSibling;

      // Close all other tabs
      headings.forEach(function(otherHeading) {
        if (otherHeading !== heading) {
          otherHeading.classList.remove('active');
          otherHeading.nextElementSibling.style.display = "none";
        }
      });

      // Toggle the clicked tab
      if (this.classList.contains('active')) {
        this.classList.remove('active');
        description.style.display = "none";
      } else {
        this.classList.add('active');
        description.style.display = "block";
        this.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
});





// var slider = new Swiper ('.gallery-slider', {
//     slidesPerView: 1,
//     centeredSlides: true,
//     loop: false,
//     loopedSlides: 6, 
//     navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//     },
// });

// var thumbs = new Swiper ('.gallery-thumbs', {
//     slidesPerView: 'auto',
//     spaceBetween: 30,
//     centeredSlides: true,
//     loop: false,
//     slideToClickedSlide: true,
// });

// // slider.controller.control = thumbs;
// thumbs.controller.control = slider;

let featured_media_index = document.querySelector('.gallery-slider .swiper-slide.swiper-slide--featured')?.getAttribute('data-index');
if (featured_media_index) {
  featured_media_index = parseInt(featured_media_index);
} else {
  featured_media_index = 0;
}


  var thumbSwiper = new Swiper('.gallery-thumbs', {
    slidesPerView: 'auto',
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    slideClass: 'swiper-slide-initial',
  });

  let gallerySliderSettings = {
    slidesPerView: 'auto',
    spaceBetween: 40,
    slideClass: 'swiper-slide-initial',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: thumbSwiper,
    }
  }

  if (document.querySelectorAll('.gallery-slider.gallery-slider-grouped')?.length < 1) {
    gallerySliderSettings.initialSlide = featured_media_index;
  }

  var mainSwiper = new Swiper('.gallery-slider', gallerySliderSettings);

  document.addEventListener("DOMContentLoaded", () => {
    // Handle slider sync on variant change
    subscribe(PUB_SUB_EVENTS.variantChange, (eventData) => {
      console.log("Event received:", eventData.data.variant);
      let selected_media_index = document.querySelector(`.gallery-slider .swiper-slide[data-variant="${eventData.data.variant.id}"]`)?.getAttribute('data-index');
      // If grouped images
      if (document.querySelector('.gallery-slider-grouped')) {
        let slideClass = `v_${eventData.data.variant.id}` || 'swiper-slide';
        let mainSwiper = document.querySelector('.gallery-slider').swiper;
        let thumbSwiper = document.querySelector('.gallery-thumbs').swiper;
        mainSwiper.destroy(false, true);
        thumbSwiper.destroy(false, true);

        document.querySelectorAll('.swiper-slide').forEach(sld => {
          if (sld.classList.contains(slideClass)) {
            sld.style.display = "block";
          } else {
            sld.style.display = "none";
          }
        })

        thumbSwiper = new Swiper('.gallery-thumbs', {
          slidesPerView: 'auto',
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideClass: slideClass,
        });
      
        mainSwiper = new Swiper('.gallery-slider', {
          slidesPerView: 'auto',
          spaceBetween: 40,
          slideClass: slideClass,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          thumbs: {
            swiper: thumbSwiper,
          }
        });

        mainSwiper.update();
        thumbSwiper.update();

      } 
      // If changing variant image only
      else {
        mainSwiper.slideTo(parseInt(selected_media_index));
      }
      

      
      
    })
  });


document.addEventListener('DOMContentLoaded', function() {
  const clientDetail = document.querySelectorAll('.article-client-profile');
  if(clientDetail.length > 0){    
      clientDetail.forEach(details => {
        const readMoreBtn = details.querySelector('.read-more');
        const truncate = details.querySelector('.truncated_desc');
        const mainDesc = details.querySelector('.main_desc');
        
        if(readMoreBtn){
         readMoreBtn.addEventListener('click', function () {
           console.log(readMoreBtn);
           if(!truncate.hasAttribute('hidden')){             
              truncate.setAttribute('hidden',true);
              mainDesc.removeAttribute('hidden');
              readMoreBtn.innerText="Learn Less";
           } else {
             truncate.removeAttribute('hidden');
             mainDesc.setAttribute('hidden', true);
             readMoreBtn.innerText="Learn More";
           }
         });
        }  
   });
  }
});



document.addEventListener('DOMContentLoaded', function() {
     const productDescription = document.querySelectorAll('.product---descriptions');
  if(productDescription.length > 0){    
      productDescription.forEach(detail => {
        const moreRead = detail.querySelector('.more_read');
        const more = detail.querySelector('.product__description');
        const mored = 'additional-readmore';
        if(moreRead){
         moreRead.addEventListener('click', function () {  
           if(!more.classList.contains(`${mored}`)){             
             more.classList.add(`${mored}`);
             moreRead.innerText="Read Less";
           } else {
             more.classList.remove(`${mored}`);
             moreRead.innerText="Read More";
           }
         });
       }   
   });
  }
});





if (document.querySelector('.blog-tab-list')) {
    const blog_tabs = document.querySelector('.blog-tab-list');
    const all_tabs = blog_tabs.querySelectorAll('.tab');
    console.log(blog_tabs);
    const handleClick = (tab) => {
        all_tabs.forEach(all_tab => {
            all_tab.classList.remove('active');
        });
        tab.classList.add('active');
        sessionStorage.setItem('activeTabId', tab.id);
    };

    all_tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            handleClick(tab);
        });
    });

    const activeTabId = sessionStorage.getItem('activeTabId');
    if (activeTabId) {
        const activeTab = document.querySelector(`#${activeTabId}`);
        if (activeTab) {
            handleClick(activeTab);
        }
    }
}

// observer 

// function handleScroll() {
//   var MainElement = document.querySelector('.main-product-custom');
//   if (!MainElement) {
//     return;
//   }
//   var buttonHeight = MainElement.offsetHeight;
//   var buttonOffsetTop = MainElement.offsetTop + buttonHeight;
//   var windowHeight = window.innerHeight;
//   var buttonOffsetBottom = MainElement.offsetTop;
//   var parentHeight = MainElement.querySelector('.product__info-wrapper').offsetHeight;
//   setTimeout(()=>{          
//     if (window.scrollY > (buttonHeight - 25)) {
//         MainElement.querySelector('product-form').classList.add('active');
//         MainElement.querySelector('.product__info-wrapper').style.height = `${parentHeight}px`;
//     } else {
//         MainElement.querySelector('product-form').classList.remove('active');
//         MainElement.querySelector('.product__info-wrapper').style.height = `auto`;
//     }
//   }, 300)
// }

// if(window.innerWidth < 750){  
//   handleScroll();
//   window.addEventListener('scroll', function() {
//       handleScroll();
//   });
// }




    const sections = document.querySelectorAll('.section_review_slider .variant-image-show');

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        } 
      });
    }, options);

    sections.forEach(section => {
      observer.observe(section);
    });

document.addEventListener('DOMContentLoaded', function() {
    const table = document.querySelector('.table-list-cover');
    const hideButton = document.querySelector('.table-hide .link');

  if(hideButton){
    hideButton.addEventListener('click', function () {
        if (table.style.display === 'block' || table.style.display === '') {
            table.style.display = 'none';
            hideButton.textContent = 'Show';
        } else {
            table.style.display = 'block';
            hideButton.textContent = 'Hide';
        }
    });
  }
});



const faqQuestions = document.querySelectorAll('.accordion-heading');

if(faqQuestions.length > 0){
  if(faqQuestions[0].nextElementSibling){    
    const firstAnswer = faqQuestions[0].nextElementSibling;
    firstAnswer.style.maxHeight = firstAnswer.scrollHeight + 'px';
  }
  faqQuestions[0].classList.add('collapsed');

  faqQuestions.forEach(function (question) {
     question.addEventListener('click', function () {
        const answer = this.nextElementSibling;

        faqQuestions.forEach(function (q) {
          if (q !== question) {
            const otherAnswer = q.nextElementSibling;
            otherAnswer.style.maxHeight = null;
            q.classList.remove('collapsed');
          }
        });

        if (!this.classList.contains('collapsed')) {
          answer.style.maxHeight = answer.scrollHeight + 'px';
          this.classList.add('collapsed');
        } else {
          answer.style.maxHeight = null;
          this.classList.remove('collapsed');
        }
     });
  });
}

var yourDiv = document.querySelector('.main-product-custom');

if(yourDiv){
  window.addEventListener('scroll', function() {
      var scroll = window.scrollY;
      if (scroll == yourDiv.offsetTop) {
          yourDiv.classList.add('sticky-quantity-product');
      }
  });
}


if (document.querySelector('.blog-tab-list')) {
    const blog_tabs = document.querySelector('.blog-tab-list');
    const all_tabs = blog_tabs.querySelectorAll('.tab');
    console.log(blog_tabs);
    const handleClick = (tab) => {
        all_tabs.forEach(all_tab => {
            all_tab.classList.remove('active');
        });
        tab.classList.add('active');
        sessionStorage.setItem('activeTabId', tab.id);
    };

    all_tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          console.log(tab);
            handleClick(tab);
        });
    });

    const activeTabId = sessionStorage.getItem('activeTabId');
    if (activeTabId) {
        const activeTab = document.getElementById(`#${activeTabId}`);
        if (activeTab) {
            handleClick(activeTab);
        }
    }
}



function hideCollectionlist() {
   document.getElementById("sticky-quantity-collection").classList.remove("show");
}     
function showCollectionlist() {
   document.getElementById("sticky-quantity-collection").classList.add("show");
}

document.querySelectorAll('.banner__buttons a').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();
    let target = document.getElementById(`${anchor.getAttribute('href').split("#")[1]}`);
    if (target.closest(`.anchor-${anchor.getAttribute('href').split("#")[1]}`)) {
      target = target.closest(`.anchor-${anchor.getAttribute('href').split("#")[1]}`);
    }
    target.scrollIntoView({ behavior: "smooth"})
  })
})
document.querySelectorAll('[href="#faq-section').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();
    let menuBtn = document.querySelector('.header__icon--menu');
    if (menuBtn.getAttribute('aria-expanded') === 'true') {
      menuBtn.click();
    }
    let target = document.getElementById(`${anchor.getAttribute('href').split("#")[1]}`);
    target.scrollIntoView({ behavior: "smooth"})
  })
})

// // BFCM bar
// if (document.querySelectorAll('.top-bar-block:not(.hide-banner)').length > 0) {
// function getTimeRemaining(endtime) {
//   const total = Date.parse(endtime) - Date.parse(new Date());
//   if (total <= 0) {
//     return {
//       total: 0,
//       days: 0,
//       hours: 0,
//       minutes: 0,
//       seconds: 0
//     };
//   }
//   const seconds = Math.floor((total / 1000) % 60);
//   const minutes = Math.floor((total / 1000 / 60) % 60);
//   const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
//   const days = Math.floor(total / (1000 * 60 * 60 * 24));

//   return {
//     total,
//     days,
//     hours,
//     minutes,
//     seconds
//   };
// }

// function initializeClock(id, endtime) {
//   const clock = document.getElementById(id);
//   const daysSpan = clock.querySelector('.days');
//   const hoursSpan = clock.querySelector('.hours');
//   const minutesSpan = clock.querySelector('.minutes');
//   const secondsSpan = clock.querySelector('.seconds');

//   function updateClock() {
//     const t = getTimeRemaining(endtime);

//     daysSpan.innerHTML = t.days;
//     hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
//     minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
//     secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

//     if (t.total <= 0) {
//       clearInterval(timeinterval);
//     }
//   }

//   updateClock();
//   const timeinterval = setInterval(updateClock, 1000);
// }

// document.querySelectorAll('.clockdivNew')?.forEach(clck => {
//   let id = clck.getAttribute('id');
//   initializeClock(id, deadline);
// })

// document.querySelectorAll('.top-bar--close')?.forEach(close => {
//   close.addEventListener('click', function(e) {
//     e.preventDefault();
//     let context = close.closest('.top-bar-block')
//     document.body.classList.add('top-bar-closed');
//     context.style.display = "none";
//     cartAtts._barClosed = true;

//     fetch(window.Shopify.routes.root + 'cart/update.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({
//         attributes: cartAtts
//       })
//     })
//         .then(response => response.json())
//         .then(data => console.log(data))
//         .catch(error => console.error('Error:', error));
//   });
// })


// function getCookie(name) {
//   let value = `; ${document.cookie}`;
//   let parts = value.split(`; ${name}=`);
//   if (parts.length === 2) return parts.pop().split(';').shift();
// }

// const bannerDiscountCode = getCookie('discount_code');
// if (bannerDiscountCode === code ) {
//   document.querySelectorAll('.top-bar--cta-wrap').forEach(el => {
//     el.classList.add('disabled');
//     el.querySelector('.button').innerHTML = "DISCOUNT APPLIED";
//   })
// } else {
//   console.log('Discount code does not match');
// }

// document.querySelectorAll('.top-bar--cta-wrap.top-bar--not-link')?.forEach(btn => {
//   btn.addEventListener('click', function(e) {
//     e.preventDefault();
//     fetch(`${window.location.origin}/discount/${code}`, {
//       method: 'GET',
//       credentials: 'same-origin'
//     })
//         .then(response => {
//           if (response.ok) {
//             document.querySelectorAll('.top-bar--cta-wrap').forEach(el => {
//               el.classList.add('disabled');
//               el.querySelector('.button').innerHTML = "APPLIED";
//             })
//             setTimeout(function() {
//               document.querySelector('.hide-after-applying')?.classList.add('hide-banner');
//             })
//           } else {
//             console.error("Failed to apply discount code.");
//           }
//         })
//         .catch(error => {
//           console.error("Error applying discount code:", error);
//         });
//   })
// })
// // Select the section-header element
// const sectionHeader = document.getElementById('top-bar--left');

// // Store the initial height of section-header when the page loads
// const initialHeaderHeight = sectionHeader.offsetHeight / 2;

// // Function to check scroll position
// function checkScrollPosition() {
//   if (window.scrollY > 1) {
//     document.body.classList.add('scrolled-sticky');
//   } else {
//     document.body.classList.remove('scrolled-sticky');
//   }
// }

// // Listen to scroll events
// window.addEventListener('scroll', checkScrollPosition);
// }

// // Price slider functionality
// class PriceSlider {
//   constructor(slider) {
//     this.slider = slider;
//     this.track = slider.querySelector(".slider-track");
//     this.minThumb = slider.querySelector(".slider-thumb-min");
//     this.maxThumb = slider.querySelector(".slider-thumb-max");

//     const parentContainer = slider.closest(".mobile-facets__submenu") || document;
//     this.minInput = parentContainer.querySelector(".price-range-input-min");
//     this.maxInput = parentContainer.querySelector(".price-range-input-max");

//     if (!this.track || !this.minThumb || !this.maxThumb || !this.minInput || !this.maxInput) {
//       console.warn("⚠️ Missing elements in slider:", slider);
//       return;
//     }

//     this.minValue = parseInt(slider.getAttribute("data-min")) || 0;
//     this.maxValue = parseInt(slider.getAttribute("data-max")) || 1000;

//     // ✅ Read the correct values from this slider only (not shared across mobile/desktop)
//     this.currentMin = parseInt(slider.getAttribute("data-current-min")) || parseInt(this.minInput.value) || this.minValue;
//     this.currentMax = parseInt(slider.getAttribute("data-current-max")) || parseInt(this.maxInput.value) || this.maxValue;

//     this.isTyping = false;

//     this.attachEvents();
//     this.updateTrack();
//     this.updateInputs(false);
//   }

//   attachEvents() {
//     this.minThumb.addEventListener("mousedown", (e) => this.handleDrag(e, "min"));
//     this.maxThumb.addEventListener("mousedown", (e) => this.handleDrag(e, "max"));

//     this.minThumb.addEventListener("touchstart", (e) => this.handleDrag(e, "min", true), { passive: false });
//     this.maxThumb.addEventListener("touchstart", (e) => this.handleDrag(e, "max", true), { passive: false });

//     this.minInput.addEventListener("change", () => this.handleInput("min"));
//     this.maxInput.addEventListener("change", () => this.handleInput("max"));

//     this.minInput.addEventListener("focus", () => (this.isTyping = true));
//     this.maxInput.addEventListener("focus", () => (this.isTyping = true));

//     this.minInput.addEventListener("blur", () => {
//       this.isTyping = false;
//       this.handleInput("min");
//     });

//     this.maxInput.addEventListener("blur", () => {
//       this.isTyping = false;
//       this.handleInput("max");
//     });
//   }

//   updateTrack() {
//     const minPercent = ((this.currentMin - this.minValue) / (this.maxValue - this.minValue)) * 100;
//     const maxPercent = ((this.currentMax - this.minValue) / (this.maxValue - this.minValue)) * 100;

//     this.track.style.left = `${minPercent}%`;
//     this.track.style.width = `${maxPercent - minPercent}%`;

//     this.minThumb.style.left = `${minPercent}%`;
//     this.maxThumb.style.left = `${maxPercent}%`;

//     this.track.style.backgroundColor = getComputedStyle(this.minThumb).backgroundColor;
//   }

//   updateInputs(triggerEvent = true) {
//     if (this.isTyping) return; // ✅ Prevent input reset while typing

//     this.minInput.value = this.currentMin;
//     this.maxInput.value = this.currentMax;

//     this.slider.setAttribute("data-current-min", this.currentMin);
//     this.slider.setAttribute("data-current-max", this.currentMax);

//     if (triggerEvent) {
//       this.minInput.dispatchEvent(new Event("input", { bubbles: true }));
//       this.minInput.dispatchEvent(new Event("change", { bubbles: true }));

//       this.maxInput.dispatchEvent(new Event("input", { bubbles: true }));
//       this.maxInput.dispatchEvent(new Event("change", { bubbles: true }));
//     }
//   }

//   handleInput(type) {
//     if (type === "min") {
//       const newValue = Math.max(this.minValue, Math.min(parseInt(this.minInput.value) || this.minValue, this.currentMax - 1));
//       if (newValue !== this.currentMin) {
//         this.currentMin = newValue;
//         this.slider.setAttribute("data-current-min", newValue);
//         this.updateTrack();
//         this.updateInputs(true);
//       }
//     } else {
//       const newValue = Math.min(this.maxValue, Math.max(parseInt(this.maxInput.value) || this.maxValue, this.currentMin + 1));
//       if (newValue !== this.currentMax) {
//         this.currentMax = newValue;
//         this.slider.setAttribute("data-current-max", newValue);
//         this.updateTrack();
//         this.updateInputs(true);
//       }
//     }
//   }

//   handleDrag(event, type, isTouch = false) {
//     event.preventDefault();
//     const sliderRect = this.slider.getBoundingClientRect();
//     const sliderWidth = sliderRect.width;

//     const getClientX = (e) => (isTouch ? e.touches[0].clientX : e.clientX);

//     const onMove = (e) => {
//       e.preventDefault();
//       const clientX = getClientX(e);
//       let offsetX = clientX - sliderRect.left;
//       offsetX = Math.max(0, Math.min(offsetX, sliderWidth));

//       const percent = (offsetX / sliderWidth) * 100;
//       const value = Math.round(this.minValue + (percent / 100) * (this.maxValue - this.minValue));

//       if (type === "min" && value < this.currentMax) {
//         this.currentMin = value;
//       } else if (type === "max" && value > this.currentMin) {
//         this.currentMax = value;
//       }

//       this.updateTrack();
//       this.updateInputs();
//     };

//     const onEnd = () => {
//       document.removeEventListener(isTouch ? "touchmove" : "mousemove", onMove);
//       document.removeEventListener(isTouch ? "touchend" : "mouseup", onEnd);
//     };

//     document.addEventListener(isTouch ? "touchmove" : "mousemove", onMove, { passive: false });
//     document.addEventListener(isTouch ? "touchend" : "mouseup", onEnd);
//   }
// }

// // ✅ Properly Reinitialize Slider AFTER Shopify AJAX Update
// function initializeSliders() {
//   console.log("🔄 Reinitializing Sliders...");
  
//   document.querySelectorAll(".slider-price").forEach(slider => {
//     // ✅ Prevent updating both sliders at the same time
//     const parentContainer = slider.closest(".mobile-facets__submenu") || document;
//     const minInput = parentContainer.querySelector(".price-range-input-min");
//     const maxInput = parentContainer.querySelector(".price-range-input-max");

//     if (minInput && maxInput) {
//       const newMin = parseInt(minInput.value) || parseInt(slider.getAttribute("data-min"));
//       const newMax = parseInt(maxInput.value) || parseInt(slider.getAttribute("data-max"));

//       slider.setAttribute("data-current-min", newMin);
//       slider.setAttribute("data-current-max", newMax);
//     }

//     new PriceSlider(slider);
//   });
// }

// // ✅ Initialize on Page Load
// document.addEventListener("DOMContentLoaded", () => {
//   initializeSliders();
// });

// // ✅ Ensure Reinitialization After Shopify AJAX Updates
// document.addEventListener("filters:updated", () => {
//     initializeSliders();
// });